// extracted by mini-css-extract-plugin
export default {"card":"Ka4_Y","card-text":"_0a4J","button":"Dz4P6"};